import Marty from "marty";
import Router from "react-router";
import routes from "./Routes";


export default Router.create({
    routes,
    location: Marty.isBrowser ? Router.HistoryLocation : undefined
});



/** WEBPACK FOOTER **
 ** ./app/config/router.js
 **/